var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#CE270B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11153_120878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 79.2188C65.5685 79.2188 79 65.7873 79 49.2188C79 32.6502 65.5685 19.2188 49 19.2188C32.4315 19.2188 19 32.6502 19 49.2188C19 65.7873 32.4315 79.2188 49 79.2188Z",
    fill: "#E13B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4324 28.0078C75.9731 33.6513 79.0612 41.2544 79.0249 49.163C78.9885 57.0717 75.8307 64.6461 70.2384 70.2384C64.6461 75.8307 57.0717 78.9885 49.163 79.0249C41.2544 79.0612 33.6513 75.9731 28.0078 70.4324L70.4324 28.0078Z",
    fill: "#D1302E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4831 49.2201L62.2747 39.4285C62.4951 39.2156 62.6709 38.961 62.7918 38.6795C62.9128 38.3979 62.9764 38.0951 62.9791 37.7887C62.9818 37.4823 62.9234 37.1784 62.8073 36.8948C62.6913 36.6112 62.52 36.3535 62.3033 36.1368C62.0866 35.9202 61.829 35.7488 61.5453 35.6328C61.2617 35.5168 60.9579 35.4584 60.6514 35.461C60.345 35.4637 60.0422 35.5273 59.7607 35.6483C59.4791 35.7692 59.2245 35.945 59.0116 36.1655L49.2201 45.957L39.4285 36.1655C38.9933 35.7451 38.4104 35.5125 37.8053 35.5177C37.2002 35.523 36.6214 35.7657 36.1936 36.1936C35.7657 36.6214 35.523 37.2002 35.5177 37.8053C35.5125 38.4104 35.7451 38.9933 36.1655 39.4285L45.957 49.2201L36.1655 59.0116C35.945 59.2245 35.7692 59.4791 35.6483 59.7607C35.5273 60.0422 35.4637 60.345 35.461 60.6514C35.4584 60.9579 35.5168 61.2617 35.6328 61.5453C35.7488 61.829 35.9202 62.0866 36.1368 62.3033C36.3535 62.52 36.6112 62.6913 36.8948 62.8073C37.1784 62.9234 37.4823 62.9818 37.7887 62.9791C38.0951 62.9764 38.3979 62.9128 38.6795 62.7918C38.961 62.6709 39.2156 62.4951 39.4285 62.2747L49.2201 52.4831L59.0116 62.2747C59.2245 62.4951 59.4791 62.6709 59.7607 62.7918C60.0422 62.9128 60.345 62.9764 60.6514 62.9791C60.9579 62.9818 61.2617 62.9234 61.5453 62.8073C61.829 62.6913 62.0866 62.52 62.3033 62.3033C62.52 62.0866 62.6913 61.829 62.8073 61.5453C62.9234 61.2617 62.9818 60.9579 62.9791 60.6514C62.9764 60.345 62.9128 60.0422 62.7918 59.7607C62.6709 59.4791 62.4951 59.2245 62.2747 59.0116L52.4831 49.2201Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11153_120878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.7f3238ebe06a216df79c9d15d17a7fe7.svg";
export { ForwardRef as ReactComponent };